import { computed } from "vue"

import DataService from "@/services/DataService.js"
import { usePage } from "@/modules/page/use"
import { usePageNumbers } from "@/modules/flatplan/usePageNumbers"
import { useContext } from "@/use/context"

// The activity log is read-only: no store, no command stack. describe.js words the rows, group.js
// groups them for display.

export const PAGE_SIZE = 50

export const useActivity = function () {
  let bp_context = useContext()
  let bp_page = usePage()
  let bp_pageNumbers = usePageNumbers()

  // what describe() words rows against: today's pages and numbering
  const ctx = computed(() => ({
    pageIds: new Set(bp_page.pages.value.map((page) => page._id)),
    order: bp_page.orderForFlatplan.value,
    numbering: bp_pageNumbers.numbering.value,
    pageNumbers: bp_pageNumbers.all.value,
  }))

  // olderThan: the last row shown, to fetch the rows after it; pageId: only the rows touching that page
  const fetchActivities = ({ olderThan, pageId } = {}) => {
    return DataService.getActivities({
      accountId: bp_context.accountId.value,
      flatplanId: bp_context.flatplanId.value,
      params: { before: olderThan?.at, beforeId: olderThan?._id, limit: PAGE_SIZE, pageId },
    }).then((response) => response.data)
  }

  return {
    ctx,
    fetchActivities,
  }
}
